
export const getHeroBannerDefaultConfig = () => {
  return {
    enabled: false,
    template: 'basic',
    data: {
      styles: {},
      components: {
        search: {
          enabled: true,
          template: 'basic',
          data: {
            styles: {},
            components: {},
          }
        },
      },
    }
  }
}

export const getFeaturedCarouselDefaultConfig = () => {
  return {
    enabled: false,
    template: 'basic',
    data: {
      styles: {},
      components: {
        assetCard: {
          enabled: true,
          template: 'basic',
          data: {
            styles: {},
            components: {
              badgesContainer: {
                enabled: true,
                template: 'basic',
                data: {
                  styles: {},
                  components: {
                    badge: {
                      enabled: true,
                      template: 'basic',
                      data: {
                        styles: {},
                        components: {},
                      }
                    }
                  },
                }
              }
            },
          }
        }
      },
    }
  }
}

export const getBrowseByCategoryDefaultConfig = () => {
  return {
    enabled: false,
    template: 'basic',
    data: {
      styles: {},
      components: {},
    }
  }
}

export const getBrowseByMakeDefaultConfig = () => {
  return {
    enabled: true,
    template: 'basic',
    data: {
      styles: {},
      components: {},
    }
  }
}

export const getContactFormSectionDefaultConfig = () => {
  return {
    enabled: false,
    template: 'basic',
    data: {
      styles: {},
      components: {},
    }
  }
}

export function getDefaultConfigForComponentType(componentType: string) {
  switch (componentType) {
    case 'heroBanner':
      return getHeroBannerDefaultConfig()
    case 'featuredCarousel':
      return getFeaturedCarouselDefaultConfig()
    case 'browseByCategory':
      return getBrowseByCategoryDefaultConfig()
    case 'browseByMake':
      return getBrowseByMakeDefaultConfig()
    case 'contactFormSection':
      return getContactFormSectionDefaultConfig()
    default:
      throw new Error(`Unknown component type: ${componentType}`)
  }
}
